module.exports = __webpack_public_path__ + "images/emoji/older_man.e917c7a6b926f001cf2a.png";